export default "__VITE_ASSET__BkHznSOC__"